import { researchPdfCovers } from '../data/researchPdfCovers';

/** First-page covers are generated ahead of time; PDFs need no CORS headers. */
export function getResearchPdfCover(url?: string | null): string | undefined {
  if (!url) return undefined;
  try {
    const filename = decodeURIComponent(new URL(url, 'https://istatec.com').pathname.split('/').pop() ?? '');
    return Object.prototype.hasOwnProperty.call(researchPdfCovers, filename)
      ? researchPdfCovers[filename] : undefined;
  } catch {
    return undefined;
  }
}
